const bar = (s) => {
  const [bass, voicing, melody, second] = s.split("|");
  let beat = 0;
  const events = (melody || "")
    .split(" ")
    .filter(Boolean)
    .map((tok) => {
      const [note, d] = tok.split(":");
      const ev = { beat, note, dur: parseFloat(d) };
      beat += ev.dur;
      return ev;
    })
    .filter((e) => e.note !== "r");
  return { bass: bass.split(" "), voicing: voicing.split(" "), events, second: second ? second.split(" ") : null };
};
const section = (rows) => rows.map(bar);

const MAJOR_A = [
  "F2 C3 A2|A3 E4 G4|E5:2 F5:.5 G5:.5",
  "D2 A2 C3|F3 C4 E4|A5:1.5 G5:.5 F5:1",
  "G2 D3 Bb2|F3 A3 Bb3|D5:1.5 F5:.5 E5:.5 D5:.5",
  "C2 E2 Bb2|Bb3 E4 A4|E5:3",
  "A2 G2 Eb2|G3 C4 E4|C5:1 E5:1 G5:1",
  "D2 F#2 Ab2|F#3 C4 Eb4|F#5:1.5 Eb5:.5 D5:1",
  "G2 D3 Db3|F3 A3 Bb3 D4|A5:2 Bb5:.5 A5:.5",
  "C3 G2 E2|Bb3 D4 E4|G5:2.5",
  "F2 A2 C3|A3 C4 E4|E5:1.5 F5:.5 A5:1",
  "F2 C2 B1|A3 Eb4 G4|Eb5:2 D5:.5 C5:.5",
  "Bb1 F2 D2|A3 D4 F4|D5:1 F5:1 A5:1",
  "Bb1 F2 Bb2|Db4 F4 G4|G5:2 F5:.5 Db5:.5",
  "A2 E2 Eb2|G3 C4 E4|C5:1.5 E5:.5 G5:1",
  "D2 A2 Ab2|F#3 C4 E4|F#5:1 A5:1 C6:1",
  "G2 D2 C2|F3 Bb3 D4|Bb5:1.5 A5:.5 G5:.5 E5:.5|Bb3 E4 A4",
  "F2 C3 F2|A3 E4 G4|F5:3",
];
const MAJOR_A2 = MAJOR_A.map((r, i) => {
  const alt = {
    0: "F2 C3 A2|A3 E4 G4|E5:1.5 G5:.5 F5:.5 E5:.5",
    3: "C2 E2 Bb2|Bb3 E4 A4|E5:2 D5:.5 E5:.5",
    7: "C3 G2 E2|Bb3 D4 E4|G5:1 A5:.5 G5:.5 E5:1",
    15: "F2 C3 F2|A3 E4 G4|F5:1 A5:1 C6:1",
  };
  return alt[i] || r;
});
const MAJOR = {
  intro: section(["F2|A3 E4 G4|", "D2|F3 C4 E4|", "G2|F3 A3 Bb3|", "C2|Bb3 D4 E4|"]),
  A: section(MAJOR_A),
  B: section([
    "Bb1 F2 A2|A3 D4 F4|D6:1.5 C6:.5 A5:1",
    "Bb1 Db2 F2|Db4 F4 G4|G5:2 F5:1",
    "A2 E2 G2|G3 C4 E4|E5:1 G5:1 C6:1",
    "D2 A2 Ab2|F#3 C4 Eb4|Bb5:1.5 A5:.5 F#5:1",
    "G2 D3 Bb2|F3 A3 Bb3 D4|A5:3",
    "C2 G2 Bb2|Bb3 E4 A4|G5:1 A5:.5 G5:.5 E5:1",
    "A2 E2 D2|G3 C4 E4|C5:1.5 D5:.5 F#5:1|F#3 C4",
    "G2 D2 C2|F3 Bb3 D4|G5:2 E5:1|Bb3 E4",
  ]),
  A2: section(MAJOR_A2),
  tag: section(["G2 D3 Db3|F3 A3 Bb3|A5:1 G5:1 E5:1", "C2 G2 E2|Bb3 D4 E4|"]),
};

const MINOR_A = [
  "D2 A2 F2|F3 C4 E4|A5:2 G5:.5 F5:.5",
  "Bb1 F2 D2|A3 D4 F4|E5:1.5 F5:.5 D5:1",
  "G2 D3 Bb2|F3 A3 Bb3|Bb5:2 A5:1",
  "A2 E2 C#2|G3 Bb3 C#4|G5:1.5 F5:.5 E5:1",
  "D2 F2 A2|F3 C4 E4|D5:1 F5:1 A5:1",
  "C2 G2 E2|Bb3 D4 F4|C6:2 Bb5:1",
  "F2 C3 A2|A3 C4 E4|A5:1.5 G5:.5 F5:1",
  "E2 Bb2 G2|Bb3 D4 G4|E5:2",
  "A2 E2 C#2|G3 C#4 F4|E5:1 C#5:1 E5:1",
  "D2 A2 F2|F3 C#4 E4|F5:3",
  "G2 D3 F2|F3 A3 Bb3|D6:1.5 C6:.5 Bb5:1",
  "C2 G2 E2|Bb3 D4 E4|A5:2 G5:1",
  "F2 A2 C3|A3 C4 E4|C5:1 F5:1 A5:1",
  "Bb1 D2 F2|A3 D4 F4|G5:1.5 F5:.5 D5:1",
  "E2 Bb2 A2|Bb3 D4 G4|E5:1.5 F5:.5 E5:.5 C#5:.5|G3 C#4 F4",
  "D2 A2 D2|F3 C4 E4|D5:3",
];
const MINOR = {
  intro: section(["D2|F3 C4 E4|", "Bb1|A3 D4 F4|", "G2|F3 A3 Bb3|", "A2|G3 Bb3 C#4|"]),
  A: section(MINOR_A),
  B: section([
    "Bb1 F2 A2|A3 D4 F4|F5:1 A5:1 D6:1",
    "A2 E2 C#2|G3 C#4 E4|C#6:2 A5:1",
    "D2 A2 C3|F3 C4 E4|D6:1.5 C6:.5 A5:1",
    "D2 F#2 A2|F#3 C4 E4|F#5:2 A5:1",
    "G2 Bb2 D3|F3 A3 Bb3|Bb5:2 A5:.5 G5:.5",
    "C2 E2 G2|Bb3 E4 G4|G5:1.5 E5:.5 C5:1",
    "F2 C3 Bb2|A3 C4 E4|A5:3",
    "A2 E2 C#2|G3 C#4 F4|E5:1 G5:1 A5:1",
  ]),
  A2: section(MINOR_A.map((r, i) => (i === 15 ? "D2 A2 D2|F3 C4 E4|D5:1 F5:1 A5:1" : r))),
  tag: section(["E2 Bb2 G2|Bb3 D4 G4|E5:1.5 F5:1.5", "A2 E2 C#2|G3 C#4 F4|"]),
};

export const SONGS = { major: MAJOR, minor: MINOR };
export const ORDER = ["intro", "A", "B", "A2", "tag"];
export const LOOP = ["A", "B", "A2", "tag"];
export const SECTION_MIX = {
  intro: { bass: 0, strings: 0.45, violin: 0, dyn: 0.8 },
  A: { bass: 1, strings: 0.7, violin: 0.35, dyn: 1 },
  B: { bass: 1, strings: 1, violin: 0.9, dyn: 1.07 },
  A2: { bass: 1, strings: 0.9, violin: 0.6, dyn: 1.03 },
  tag: { bass: 0.8, strings: 0.6, violin: 0.3, dyn: 0.92 },
};
export const PHRASE = [1.02, 0.98, 0.97, 1.08];
export const LILT = [1.0, 0.97, 1.03];
export const HALL_MOOD = { song: "major", key: 0, bpm: 88, comp: "waltz", melody: "full", bass: "walk", strings: 0.22, violin: 0.16, octave: 0 };
export const BENCH_MOOD = { song: "major", key: 5, bpm: 62, comp: "arp", melody: "sparse", bass: "pedal", strings: 0.34, violin: 0.24, octave: 12 };
export const CHIME = ["F5", "G5", "A5", "C6", "D6"];
